import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import useSpaceEnabledContentTypesQuery from './CreateContentPopover/__generated__/useSpaceEnabledContentTypesQuery.graphql.ts';
import type {
	useSpaceEnabledContentTypesQuery$data,
	useSpaceEnabledContentTypesQuery$variables,
} from './CreateContentPopover/__generated__/useSpaceEnabledContentTypesQuery.graphql.ts';
import type { GraphQLErrorPayload as GraphQLErrorInterop } from '@confluence/relay-errors/entry-points/RelayError.ts';

export function preloadSpaceEnabledContentTypes(spaceKey: string): Promise<{
	data: useSpaceEnabledContentTypesQuery$data | null;
	errors?: ReadonlyArray<GraphQLErrorInterop>;
	hasErrors: boolean;
}> {
	return query<useSpaceEnabledContentTypesQuery$data, useSpaceEnabledContentTypesQuery$variables>({
		query: useSpaceEnabledContentTypesQuery,
		errorPolicy: 'all',
		variables: {
			spaceKey,
		},
	});
}
